import { jsPDF } from "jspdf";

const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_ref-connect-app/artifacts/02ztij1f_logo.png";

async function fetchImageAsDataURL(url) {
  const res = await fetch(url, { mode: "cors" });
  const blob = await res.blob();
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/**
 * Generate & auto-download the "Thank You" welcome PDF for a newly
 * registered user. Mirrors the design provided by the client.
 */
export async function downloadWelcomePdf({ name, user_code, password }) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();

  // ---------- Header band (maroon) ----------
  const headerH = 90;
  doc.setFillColor(91, 15, 15); // #5b0f0f
  doc.rect(0, 0, pageW, headerH, "F");

  // Logo (best-effort; skip on CORS failure)
  try {
    const dataUrl = await fetchImageAsDataURL(LOGO_URL);
    doc.addImage(dataUrl, "PNG", 40, 18, 55, 55);
  } catch (err) {
    console.warn("Welcome PDF logo could not be loaded:", err);
    /* logo unavailable — continue without */
  }

  doc.setTextColor(255, 255, 255);
  doc.setFont("times", "bold");
  doc.setFontSize(28);
  doc.text("UNIQUE DEAL INDIA", 110, 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Earn While You Learn", 110, 72);

  // ---------- Body ----------
  doc.setTextColor(20, 20, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(38);
  doc.text("Thank You!", pageW / 2, 170, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(13);
  const welcome =
    "Congratulations and welcome to the team, Our company is growing and " +
    "changing every day and we're thrilled to have you along for the ride.";
  const wrapped = doc.splitTextToSize(welcome, pageW - 120);
  doc.text(wrapped, pageW / 2, 210, { align: "center" });

  // Credentials block
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  const startY = 320;
  const lineGap = 40;
  doc.text(`Name: ${name}`, 70, startY);
  doc.text(`User Id: ${user_code}`, 70, startY + lineGap);
  doc.text(`Password: ${password}`, 70, startY + lineGap * 2);

  // Footer note
  doc.setFont("helvetica", "italic");
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  doc.text(
    "Please keep this document safe. Do not share your password with anyone.",
    pageW / 2,
    doc.internal.pageSize.getHeight() - 40,
    { align: "center" }
  );

  const safeName = (name || "user").replace(/\s+/g, "_");
  doc.save(`UDI_Welcome_${safeName}_${user_code}.pdf`);
}
